<app-folder-breadcrumb [folder]="currentFolder()" (selectFolder)="selectFolder($event)"></app-folder-breadcrumb>

<div class="folder-menu">
  <div class="folder-menu-content" [class.block-galleries]="blockGallerySelection()" (click)="selectGallery(undefined)">
    @if (noResults()) {
      <div class="no-folders">
        <span>Empty</span>
      </div>
    }
    <app-finder-content
      #finderContent
      (onSelectFolder)="selectFolder($event)"
      (onSelectGallery)="selectGallery($event)"
      (onResultsUpdated)="noResults.set(!$event.length)"
      [allGalleries]="allGalleries()"
      [allFolders]="allFolders()"
      [currentFolder]="currentFolder()"
      [currentGallery]="currentGallery()"
      [filterOut]="filterOut()"
      [disableList]="disableList()"
      [blockGallerySelection]="blockGallerySelection()"
      [hideSubGalleries]="hideSubGalleries()"
      [folderMode]="folderMode()"
    ></app-finder-content>
  </div>
</div>
